
import {computed, defineComponent} from 'vue';
import {useStore} from "vuex";
import {useRoute} from "vue-router"; // @ is an alias to /src

export default defineComponent({
  name: 'SinglePost',
  components: {},
  setup() {
    const store = useStore();
    const route = useRoute()
    const post = computed(() => store.getters.allPosts.find((post:any) => post.slug === route.params.slug))

    return {
      post,
      upvote: () => store.dispatch('upvote', route.params.slug),
    }
  },
});
